var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import useFieldApi from "@data-driven-forms/react-form-renderer/dist/cjs/use-field-api";
import React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Flex } from "../../Flex";
import { InputWithSubmit } from "../InputWithSubmit/InputWithSubmit";
import i18next from "i18next";
import parse from "html-react-parser";
import { SvgIcon } from "../../../icons";
import { COUPON_CODE, COUPON_CODE_BUTTON, COUPON_CODE_BUTTON_APPLY, COUPON_CODE_BUTTON_CLEAR } from "../../../classConstants";
import { getClassName } from "../../../helpers";
var ResultType;
(function (ResultType) {
    ResultType[ResultType["SUCCESS"] = 1] = "SUCCESS";
    ResultType[ResultType["ERROR"] = 0] = "ERROR";
})(ResultType || (ResultType = {}));
var CouponCode = /** @class */ (function (_super) {
    __extends(CouponCode, _super);
    function CouponCode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            code: null,
            result: "",
            resultType: null,
            lastCheckedCode: "",
            submitting: false,
        };
        _this.handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var code, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        code = this.state.code;
                        if (!this.isCodeSameAsApplied) return [3 /*break*/, 2];
                        this.removeCode();
                        this.props.onChange("");
                        return [4 /*yield*/, this.props.onSubmit("", 1)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        this.setState({ lastCheckedCode: code, submitting: true });
                        return [4 /*yield*/, this.props.onSubmit(code)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        this.handleError(e_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.removeCode = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState({
                    code: "",
                    result: "",
                    resultType: null,
                    lastCheckedCode: "",
                });
                return [2 /*return*/];
            });
        }); };
        _this.handleSuccess = function () {
            var _a;
            _this.props.onChange(_this.state.code);
            _this.setState({ result: (_a = _this.props.discountCodeStatus) === null || _a === void 0 ? void 0 : _a.message, resultType: ResultType.SUCCESS, submitting: false });
        };
        _this.onTextChange = function (code) {
            _this.setState({ code: code });
        };
        _this.handleError = function (e) {
            var message = i18next.t("paybook.coupon_code.error");
            var code = _this.state.lastCheckedCode;
            if (e.messageText) {
                message = e.messageText;
            }
            else {
                code = "";
            }
            _this.setState({
                result: message,
                resultType: ResultType.ERROR,
                lastCheckedCode: code,
                submitting: false,
            });
        };
        return _this;
    }
    Object.defineProperty(CouponCode.prototype, "isCodeSameAsApplied", {
        get: function () {
            return this.state.lastCheckedCode === this.state.code;
        },
        enumerable: false,
        configurable: true
    });
    CouponCode.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (this.state.code === null && this.props.value) {
            var oldPrevProps = __assign({}, prevProps);
            this.setState({
                code: this.props.value,
                lastCheckedCode: this.props.value,
            }, function () {
                _this.syncState();
            });
            return;
        }
        if (this.props.discountCodeStatus === prevProps.discountCodeStatus) {
            if (this.props.hasError) {
                this.handleError({});
            }
        }
        else {
            this.syncState();
        }
    };
    CouponCode.prototype.syncState = function () {
        if (this.props.discountCodeStatus === null) {
            this.removeCode();
        }
        else if (this.props.discountCodeStatus.is_an_error === false) {
            this.handleSuccess();
        }
        else {
            this.handleError({ message: this.props.discountCodeStatus.status, messageText: this.props.discountCodeStatus.message });
        }
    };
    CouponCode.prototype.getInputProps = function () {
        var _a;
        var showClearIcon = this.state.code && this.isCodeSameAsApplied;
        return {
            label: "",
            value: this.state.code || "",
            name: this.props.name,
            wrapperClassName: COUPON_CODE,
            buttonClassName: getClassName(COUPON_CODE_BUTTON, (_a = {},
                _a[COUPON_CODE_BUTTON_APPLY] = !showClearIcon,
                _a[COUPON_CODE_BUTTON_CLEAR] = showClearIcon,
                _a)),
            minLength: this.props.minLength,
            leftIcon: showClearIcon ? React.createElement(Icon, { type: "close" }) : React.createElement(Icon, { type: "arrowright" }),
            submitLabel: showClearIcon ? i18next.t("paybook.coupon_code.clear_code") : i18next.t("paybook.coupon_code.apply_code"),
            placeholder: i18next.t("paybook.coupon_code.placeholder"),
            onSubmit: this.handleSubmit,
            onChange: this.onTextChange,
        };
    };
    CouponCode.prototype.renderResult = function () {
        var result = this.state.result;
        if (!result) {
            return null;
        }
        return (React.createElement(CouponCodeResult, { className: "" },
            React.createElement(Result, null, parse(result))));
    };
    CouponCode.prototype.render = function () {
        var wrapProps = {
            hasSuccess: this.state.resultType === ResultType.SUCCESS,
            hasError: this.state.resultType === ResultType.ERROR,
        };
        return (React.createElement(CouponCodeWrap, __assign({}, wrapProps),
            React.createElement(CouponCodeHeader, null, i18next.t("paybook.coupon_code.title")),
            React.createElement(CouponCodeField, null,
                React.createElement(InputWithSubmit, __assign({}, this.getInputProps())),
                this.renderResult())));
    };
    CouponCode.defaultProps = {
        discountCodeStatus: null,
    };
    return CouponCode;
}(React.PureComponent));
export { CouponCode };
export var ReactiveCouponCode = React.memo(function (props) {
    var dispatch = useDispatch();
    var reactiveProps = useFieldApi(props);
    var onSubmit = props.onSubmit;
    if (props.shouldDispatch) {
        var ogSubmit_1 = onSubmit;
        onSubmit = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return dispatch(ogSubmit_1.apply(void 0, args));
        };
    }
    return React.createElement(CouponCode, __assign({}, props, reactiveProps.input, { onSubmit: onSubmit }));
});
var CouponCodeResult = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n"], ["\n"])));
var CouponCodeWrap = styled(Flex).attrs(function (props) { return ({ hasSuccess: props["hasSuccess"], hasError: props["hasError"] }); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", " {\n        display: inline-block;\n        color: var(--ws-coupon-code-color);\n        background: var(--ws-coupon-code-bg);\n        padding: var(--ws-coupon-code-padding, 1em);\n        border-radius: var(--ws-coupon-code-border-radius, 4px);\n        border:  var(--ws-coupon-code-border, 1px solid);\n        border-color:  var(--ws-coupon-code-border-color);\n\n        ", "\n    \n        ", "\n    }\n"], ["\n    ", " {\n        display: inline-block;\n        color: var(--ws-coupon-code-color);\n        background: var(--ws-coupon-code-bg);\n        padding: var(--ws-coupon-code-padding, 1em);\n        border-radius: var(--ws-coupon-code-border-radius, 4px);\n        border:  var(--ws-coupon-code-border, 1px solid);\n        border-color:  var(--ws-coupon-code-border-color);\n\n        ",
    "\n    \n        ",
    "\n    }\n"])), CouponCodeResult, function (props) {
    return !props.hasSuccess ? "" : "\n                --ws-coupon-code-bg: var(--ws-coupon-code-success-bg);\n                --ws-coupon-code-color: var(--ws-coupon-code-success-color);\n                --ws-coupon-code-border-color: var(--ws-coupon-code-success-border-color);\n            ";
}, function (props) {
    return !props.hasError ? "" : "\n                --ws-coupon-code-bg: var(--ws-coupon-code-error-bg);\n                --ws-coupon-code-color: var(--ws-coupon-code-error-color);\n                --ws-coupon-code-border-color: var(--ws-coupon-code-error-border-color);\n            ";
});
var CouponCodeField = styled(Flex)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    gap: 1em;\n"], ["\n    gap: 1em;\n"])));
var Result = styled.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0 !important;\n"], ["\n    margin: 0 !important;\n"])));
var CouponCodeHeader = styled.h3(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 100%;\n    margin-top: 0;\n    margin-bottom: .5em;\n"], ["\n    width: 100%;\n    margin-top: 0;\n    margin-bottom: .5em;\n"])));
var Icon = styled(SvgIcon)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    height: 1em;\n"], ["\n    height: 1em;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
